import { Badge } from "@/components/ui/badge";

import type { JobStatus } from "@/api/types";

/**
 * Maps each of the 9 platform job states to a {@link Badge} variant. The
 * mapping clusters states by lifecycle position:
 *
 * - **In-flight** (`running`, `validating`, `pending_review`,
 *   `committing`) → `accent` (gold). All four indicate active work.
 * - **Queued** → `default` (muted). Not yet picked up.
 * - **Terminal success** (`completed`) → `success` (emerald).
 * - **Terminal failure** (`failed`, `expired`) → `danger` (red).
 * - **Cancelled** → `muted` (very low contrast). Not an error, not a
 *   success — just stopped.
 */
const STATUS_VARIANT: Record<JobStatus, "default" | "accent" | "success" | "danger" | "muted"> = {
  queued: "default",
  running: "accent",
  validating: "accent",
  pending_review: "accent",
  committing: "accent",
  completed: "success",
  failed: "danger",
  expired: "danger",
  cancelled: "muted",
};

export function StatusBadge({ status }: { status: JobStatus }) {
  return <Badge variant={STATUS_VARIANT[status]}>{status.replace(/_/g, " ")}</Badge>;
}
